import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";

const COLORS = {
  main: "#13816F",
  headLight: "#19A58D",
  pastel1: "#CFF0EA",
  pastel2: "#E3F7F3",
  faded: "#F3FBF9",
};

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export default function AgencyTermSummary({
  title = "",
  info = {},
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {forma &&
          Object.entries(forma).map(([field_name, field_value]) => (
            <input
              key={field_name}
              type="hidden"
              name={field_name}
              value={field_value}
              readOnly
            />
          ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "#fff", borderRadius: 8 }}
            >
              {/* Header */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(13, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(13, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Main Table */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {/* Detalle por grupo */}
                    {info.details &&
                      Object.entries(info.details).map(
                        ([row_name, row_val]) => {
                          return (
                            <React.Fragment key={row_name}>
                              <TableRow>
                                <TableCell
                                  colSpan={4}
                                  style={{
                                    background: COLORS.main,
                                    color: "#fff",
                                    fontWeight: 700,
                                  }}
                                >
                                  {row_name}
                                </TableCell>
                              </TableRow>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  &nbsp;
                                </TableCell>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  Count
                                </TableCell>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  Avg Days
                                </TableCell>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  Net Prem
                                </TableCell>
                              </TableRow>
                              {Object.entries(row_val).map((row, idx) => {
                                row = row[1];
                                return (
                                  <TableRow
                                    key={idx}
                                    className="odd gradeX"
                                    style={{ textAlign: "right" }}
                                  >
                                    <TableCell>{row.term}</TableCell>
                                    <TableCell>{row.count}</TableCell>
                                    <TableCell>
                                      {Math.round(row.days / row.count)}
                                    </TableCell>
                                    <TableCell>${fmtMoney(row.net)}</TableCell>
                                  </TableRow>
                                );
                              })}
                            </React.Fragment>
                          );
                        }
                      )}
                    {/* Totales */}
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        style={{
                          background: COLORS.main,
                          color: "#fff",
                          fontWeight: 700,
                        }}
                      >
                        Total
                      </TableCell>
                    </TableRow>
                    <TableRow style={{ textAlign: "center" }}>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        &nbsp;
                      </TableCell>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        Count
                      </TableCell>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        Avg Days
                      </TableCell>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        Net Prem
                      </TableCell>
                    </TableRow>
                    {info.totales &&
                      Object.entries(info.totales).map((row, idx) => (
                        <TableRow
                          key={idx}
                          className="odd gradeX"
                          style={{ textAlign: "right" }}
                        >
                          <TableCell>{row.term}</TableCell>
                          <TableCell>{row.count}</TableCell>
                          <TableCell>
                            {Math.round(row.days / row.count)}
                          </TableCell>
                          <TableCell>${fmtMoney(row.net)}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Bottom Buttons */}
              <GridContainer style={{ marginTop: 16 }}>
                <GridItem xs={12} sm={6}>
                  &nbsp;
                </GridItem>
                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(13, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(13, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>
                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
